import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

// Accept the onLogout prop
const MainLayout = ({ user, theme, toggleTheme, onLogout }) => {
  return (
    <div>
      {/* Pass all props down to the Sidebar */}
      <Sidebar user={user} theme={theme} toggleTheme={toggleTheme} onLogout={onLogout} />
      <div className="content-wrapper" style={{ marginLeft: '50px' }}>
          <Header user={user} />
          <main className="scrollable-content">
            <Outlet />
          </main>
      </div>
    </div>
  );
};

export default MainLayout;